import api from '../api';

export const productsFetchSuccess = (products) => {
    return {
        type: 'PRODUCTS_FETCH_SUCCESS',
        products
    };
};

export function loadProducts() {
    return (dispatch) => {
        return api.getProducts().then(response => {
            dispatch(productsFetchSuccess(response));
        }).catch(error => {
            throw(error);
        });
    };
}

export function filterMatches(properties, state) {
    if(!state.products || !state.matches || !state.matches[properties.category]) return [];

    let matches = state.matches[properties.category];
    matches = matches[properties.floorSurface];
    matches = matches[properties.option];

    let products = [];
    if(!matches) return false;

    for (let i = 0, len = state.products.length; i < len; i++) {
        const product = state.products[i];
        if(matches.indexOf(product.id) >= 0) {
            products.push(product);
        }
    }

    return products;
}

export function getProducts(ids, products) {

    let response = [];

    for (let i = 0, len = products.length; i < len; i++) {
        const product = products[i];
        if(ids.indexOf(product.id) >= 0) {
            response.push(product);
        }
    }

    return response;

}


export function getProduct(slug, state) {

    let response = [];

    for (let i = 0, len = state.products.length; i < len; i++) {
        const product = state.products[i];
        if(slug == product.slug) {
            response.push(product);
        }
    }

    return response;

}




// WEBPACK FOOTER //
// ./src/actions/productActions.js